var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299 299",
    width: 299,
    height: 299,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 307,
    height: 361,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzA2LjIyNCIgaGVpZ2h0PSIzNjAuMzk2IiB2aWV3Qm94PSIwIDAgMzA2LjIyNCAzNjAuMzk2Ij4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iMC41IiB4Mj0iMC41IiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNjMTQ4ZTUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjY1NyIgc3RvcC1jb2xvcj0iIzkzMmRkNSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1YTQ4ZDQiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDUyNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDUyNyIgd2lkdGg9IjE3MCIgaGVpZ2h0PSIzMTgiIHJ4PSI4NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA4NSkgcm90YXRlKC0zMCkiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPgo8L3N2Zz4K"
  }), /*#__PURE__*/React.createElement("image", {
    width: 361,
    height: 307,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzYwLjM5NiIgaGVpZ2h0PSIzMDYuMjI0IiB2aWV3Qm94PSIwIDAgMzYwLjM5NiAzMDYuMjI0Ij4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iMC41IiB4Mj0iMC41IiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNjMTQ4ZTUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjY1NyIgc3RvcC1jb2xvcj0iIzkzMmRkNSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1YTQ4ZDQiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDUyOCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDUyOCIgd2lkdGg9IjE3MCIgaGVpZ2h0PSIzMTgiIHJ4PSI4NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxNDcuMjI0KSByb3RhdGUoLTYwKSIgb3BhY2l0eT0iMC41IiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KPC9zdmc+Cg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Rectangle 4527",
    href: "#img1",
    transform: "matrix(1,0,0,1,-4,-31)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Rectangle 4528",
    href: "#img2",
    transform: "matrix(1,0,0,1,-31,-4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderBg);
export default __webpack_public_path__ + "static/media/founderBg.10289ded367eaf36ed22f9c9ab490e42.svg";
export { ForwardRef as ReactComponent };